import { defineMessages } from 'react-intl'

const scope = 'app.components.BusinessSummary'

export default defineMessages({
  headers: {
    hosts: {
      id: `${scope}.headers.hosts`,
      defaultMessage: 'Hosts',
    },
    listings: {
      id: `${scope}.headers.listings`,
      defaultMessage: 'Listings',
    },
  },
  fields: {
    businessType: {
      id: `${scope}.fields.businessType`,
      defaultMessage: 'Industry',
    },
    incorpDate: {
      id: `${scope}.fields.incorpDate`,
      defaultMessage: 'Registration',
    },
    firstActivityDate: {
      id: `${scope}.fields.firstActivityDate`,
      defaultMessage: 'First Activity',
    },
    employees: {
      id: `${scope}.fields.employees`,
      defaultMessage: 'Employees',
    },
    location: {
      id: `${scope}.fields.location`,
      defaultMessage: 'Business Locations',
    },
    reported: {
      id: `${scope}.fields.reported`,
      defaultMessage: 'Reported',
    },
    estimated: {
      id: `${scope}.fields.estimated`,
      defaultMessage: 'Estimated',
    },
    documentedIncome: {
      id: `${scope}.fields.documentedIncome`,
      defaultMessage: 'Documented',
    },
  },
})
